<template>
    <div class="account_center">
        <ul class="box">
            <li>
                <div><i class="iconfont icon-zuokuohao" @click="$router.go(-1)">返回</i></div>
                <el-image
                    fit="cover"
                    style="width:150px;min-width:150px;height:150px;cursor:pointer;"
                    :src="getUserInfo.access_avatar"
                    @click="upload_avatar"
                >
                    <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                        <div class="el_image">
                            <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:14px"></span>
                        </div>
                    </div>
                    <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                        <div class="el_image">
                            <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>
                        </div>
                    </div>
                </el-image>
                <input type="file" v-show="false" ref="avatar_input"  @change="uploadAvatar" accept="image/png,image/jpeg,image/jpg,image/gif,image/svg,image/ico"/>
            </li>
            <li>
                <i><img src="@/assets/img/3.png" alt=""></i>
                <div>
                    <div>
                        <h3>账号信息</h3>
                        <p>账号、昵称、所属公司、客户等级、联系方式</p>
                    </div>
                    <div>
                        <button @click="modify_account.dialogInfo=true">详情</button>
                    </div>
                </div>
            </li>
            <li>
                <i><img src="@/assets/img/2.png" alt=""></i>
                <div>
                    <div>
                        <h3>账号密码</h3>
                        <p>用来保护账号信息和登录安全</p>
                    </div>
                    <div>
                        <button @click="modify_passwords(1)">修改</button>
                    </div>
                </div>
            </li>
            <li class="exit_account">
                <span class="iconfont icon-tuichu3" @click="ExitAccount"> 退出账号</span>
            </li>
        </ul>
        <!-- 账号信息 -->
        <el-dialog
            class="account_info"
            title="账号信息"
            :modal="false"
            :visible.sync="modify_account.dialogInfo"
            :modal-append-to-body='false'
            width="600px">
            <ul class="modal_content">
                <li>
                    <h3>LOGO(头像)</h3>
                    <el-image
                        fit="cover"
                        style="width:150px;min-width:150px;height:150px"
                        :src="getUserInfo.access_avatar"
                    >
                        <div slot="placeholder" class="image-slot" style="width:100%;height:100%;">
                            <div class="el_image">
                                <span class="dot" v-loading="true"  element-loading-spinner="el-icon-loading" style="font-size:14px"></span>
                            </div>
                        </div>
                        <div slot="error" class="image-slot"  style="width:100%;height:100%;">
                            <div class="el_image">
                                <el-image  fit="cover" :src="src.src_err"  style="width:70px;height:70px;"></el-image>
                            </div>
                        </div>
                    </el-image>
                </li>
                <li>
                    <h3>用&nbsp;&nbsp;户&nbsp;&nbsp;名</h3>
                    <p>{{getUserInfo.username}}</p>
                </li>
                <li>
                    <h3>昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称</h3>
                    <p>{{getUserInfo.nickname}}</p>
                </li>
                <li>
                    <h3>所属公司</h3>
                    <p>{{getUserInfo.company_name}}</p>
                </li>
                <li>
                    <h3>客户等级</h3>
                    <p>{{getUserInfo.custom_level_name}}</p>
                </li>
                <li>
                    <h3>联系方式</h3>
                    <p>{{getUserInfo.phone}}</p>
                </li>
                <li>
                    <h3>客服专员</h3>
                    <p>{{getUserInfo.charge_nickname}}</p>
                </li>
                <li>
                    <h3>客服电话</h3>
                    <p>{{getUserInfo.charge_phone}}</p>
                </li>
            </ul>
        </el-dialog>
        <!-- 账号密码 -->
        <el-dialog
            class="account_password"
            title="账号密码"
            :modal="false"
            :visible.sync="modify_password.dialogPassword"
            :before-close="handleClose"
            width="600px">
            <ul class="modal_content">
                <li>
                    <h3>原密码</h3>
                    <div>
                        <el-input placeholder="请输入原密码" v-model="modify_password.oldPassword" show-password autocomplete="off" ></el-input>
                        <p class="tip" ref='pass1'></p>
                    </div>
                </li>
                <li>
                    <h3>新密码</h3>
                    <div >
                        <el-input placeholder="请输入新密码" v-model="modify_password.newPassword" show-password></el-input>
                        <p class="tip" ref='pass2'>密码必须为6-16位字母和数字组合</p>
                    </div>
                </li>
                <li>
                    <h3>确认密码</h3>
                    <div>
                        <el-input placeholder="再次确认新密码" v-model="modify_password.confirmPassword" show-password></el-input>
                        <p class="tip" ref='pass3'></p>
                    </div>
                </li>
                <li>
                    <div>
                        <h3>验证码短信将发送至&nbsp;&nbsp;<span>{{getUserInfo.phone | filterPhone}}</span></h3>
                        <p v-show="modify_password.isactive">重新获取(<i>{{modify_password.num>9?modify_password.num:'0'+modify_password.num}}</i>s)</p>
                    </div>
                    <div class="checkma">
                        <el-input v-model="modify_password.check_code" placeholder="请输入短信验证码"></el-input><button :disabled='modify_password.isactive'  :class='{active : modify_password.isactive}' @click="getCheckCode('modify_password.num','modify_password.isactive')">获取验证码</button><br/>
                    </div>
                     <p class="tip" ref='check'></p>
                </li>
            </ul>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="modify_passwords(2)">完成</el-button>
            </span>
        </el-dialog>
        <!-- 验证账号 -->
        <el-dialog
            class="verify_message"
            title="账号信息"
            :modal="false"
            width="600px"
            :modal-append-to-body='false'
            :visible.sync="verify_account.dialogAccount"
            :before-close="handleClose">
            <ul class="modal_content">
                <li>为了保护您的账号安全，需要验证您的账号</li>
                <li>
                    <div>
                        <h3>验证码短信将发送至&nbsp;&nbsp;<span>{{getUserInfo.phone | filterPhone}}</span></h3>
                        <p v-show="verify_account.isactive">重新获取(<i>{{verify_account.num>9?verify_account.num:'0'+verify_account.num}}</i>s)</p>
                    </div>
                    <div class="checkma">
                        <el-input v-model="verify_account.checkCode" placeholder="请输入短信验证码"></el-input><button :disabled='verify_account.isactive'  :class='{active : verify_account.isactive}' @click="getCheckCode('verify_account.num','verify_account.isactive')">获取验证码</button>
                    </div>
                </li>
                <li>
                    <el-button type="primary" >完成</el-button>
                </li>
                <li>
                    <b>验证码错误</b>
                    <p>短信可能会有延时，请耐心等待，如果长时间未收到短信，请60秒后重新获取</p>
                </li>
            </ul>
        </el-dialog>
        <!-- 绑定手机号 -->
        <el-dialog
            class="bind_phone"
            title="绑定安全手机"
            :modal="false"
            :modal-append-to-body='false'
            :visible.sync="bind_phone.dialogPhone"
            :before-close="handleClose"
            width="600px">
            <ul class="modal_content">
                <li>
                    <h3>请输入要绑定的手机</h3>
                    <div>
                        <el-input v-model="bind_phone.newPhone"  placeholder="请输入要绑定的手机号" class="input"></el-input>
                        <el-select v-model="bind_phone.area" placeholder="选择区号" class="select">
                            <el-option
                                v-for="item in bind_phone.options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <p ref='phone1'>ss</p>
                </li>
                <li>
                    <div class="checkma">
                        <el-input v-model="bind_phone.checkCode" placeholder="请输入短信验证码"></el-input><button :disabled='bind_phone.isactive'  :class='{active : bind_phone.isactive}' @click="getCheckCode('bind_phone.num','bind_phone.isactive')"><i v-show="!bind_phone.isactive">获取验证码</i><i v-show="bind_phone.isactive">重新获取 {{bind_phone.num>9?bind_phone.num:'0'+bind_phone.num}}s</i></button>
                    </div>
                    <p ref='phone2'>ss</p>
                </li>
                <li>
                    <el-button type="primary" >完成</el-button>
                </li>
                <li>
                    <b>验证码错误</b>
                    <p>短信可能会有延时，请耐心等待，如果长时间未收到短信，请60秒后重新获取</p>
                </li>
            </ul>
        </el-dialog>
    </div>
</template>
<script>
import crypto from 'crypto';
import { setInterval, clearInterval, setTimeout } from 'timers';
import YxUpyun from "@/utils/YxUpyun";
import src_err from '@/assets/img/err.png'

export default {
    name:"account_center",
    data(){
        return {
            src:{
                src_err,
            },
            // 账号信息
            modify_account:{
                dialogInfo:false,
                url:'',
                userName:''
            },
            // 账户密码
            modify_password:{
                dialogPassword:false,
                oldPassword:'',
                newPassword:'',
                confirmPassword:'',
                check_code:'',
                isactive:false,
                num:59,
            },
            // 验证账户
            verify_account:{
                dialogAccount:false,
                check_code:'',
                isactive:false,
                num:59,
            },
            // 绑定手机
            bind_phone:{
                dialogPhone:false,
                newPhone:'',
                check_code:'',
                isactive:false,
                num:59,
                options: [{
                    value: '选项1',
                    label: '+86'
                }],
                area:'+86',
            },
        }
    },
    computed:{
        getUserInfo(){
            return this.$store.getters.get_userInfo
        }
    },
    methods:{
        handleClose(done) {
            this.clear_input()
            done();
        },
        // 打开上传input
        upload_avatar(){
            this.$confirm('是否更换当前头像?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.avatar_input.click()
            }).catch(() => {});
        },
        // 上传头像
        uploadAvatar(){
            let file=this.$refs.avatar_input.files[0]
            YxUpyun.upload(file, "/imi_jxs/offline/img").then(res => {
                if(res.status===200){
                    let img_info={
                        file_type: 'img',
                        file_size:file.size,
                        file_name:file.name,
                        file_url:res.data.url,
                        img_status:'effective',
                    }
                    this.$http({
                        url:'modify_avatar',
                        data:{
                            uhash:this.getUserInfo.uhash,
                            img_info:YxUpyun.Base64.encode(JSON.stringify([img_info]))
                        }
                    }).then((res)=>{
                        if(res.code===1){
                            let userInfo=this.getUserInfo
                            userInfo.access_avatar='http://upyun.yuximi.com'+img_info.file_url

                            this.$store.commit({
                                type:'set_userInfo',
                                data:userInfo
                            })
                            this.$message({
                                type: 'success',
                                message: '更换成功!'
                            });
                        }
                    }).catch(()=>{})
                }
            }).catch(() => {});
            // 清除input file
            let input = this.$refs.avatar_input;
            YxUpyun.clearInputFile(input);
        },
        // 账户密码
        modify_passwords(o){
            if(o===1){
                this.modify_password.dialogPassword=true
            }else if(o===2){
                let isTrue=this.form_check()
                if(isTrue==false){
                    return
                }
                console.log(this.getUserInfo.uhash)
                this.$http({
                    url:'modify_password',
                    data:{
                        phone:this.getUserInfo.phone,
                        uhash:this.getUserInfo.uhash,
                        sms_code:this.modify_password.check_code,
                        oldpassword:crypto.createHash('md5').update(this.modify_password.oldPassword).digest('hex'),
                        newpassword:crypto.createHash('md5').update(this.modify_password.newPassword).digest('hex')
                    }
                }).then((res)=>{
                    if(res.code==1){
                        this.$message({
                            message:`修改成功,请重新登录`,
                            type: 'success'
                        });
                        this.$store.commit({
                            type:'set_userInfo',
                            data:{}
                        })
                        setTimeout(()=>{
                            this.$router.push("/login")
                        },500)
                    }
                }).catch((err)=>{
                    console.log(err)
                })
            }
        },
        // 获取验证码
        getCheckCode(o,t){
            this.$http({
                url:'send_check_code',
                data:{
                    phone:this.getUserInfo.phone
                }
            }).then((res)=>{
                if(res.code==1){
                    this.$message({
                        message:`${res.msg}`,
                        type: 'success'
                    });
                }
            }).catch((err)=>{
                console.log(err)
            })
            eval(`this.${t}=true
                let timer=setInterval(()=>{
                    if(this.${o}>0){
                        this.${o}--
                    }else{
                        clearInterval(timer)
                        this.${t}=false
                        this.${o}=59
                    }
                },1000)`)
        },
        // 表单验证
        form_check(){
            // 原密码
            if(this.modify_password.oldPassword==''){
                this.$refs.pass1.innerHTML='请输入密码'
                return false
            }else{
                this.$refs.pass1.innerHTML=''
            }

            // 新密码
            let password=/^\w{6,16}/g
            if(this.modify_password.newPassword==''){
                this.$refs.pass2.innerHTML='请输入新密码'
                return false
            }else if(!password.test(this.modify_password.newPassword)){
                this.$refs.pass2.innerHTML='密码格式不正确'
                return false
            }else{
                this.$refs.pass2.innerHTML=''
            }

            // 确认密码
            if(this.modify_password.confirmPassword==''){
                this.$refs.pass3.innerHTML='请输入确认密码'
                return false
            }else if(this.modify_password.confirmPassword!==this.modify_password.newPassword){
                this.$refs.pass3.innerHTML='密码不一致，请重新输入'
                return false
            }else{
                this.$refs.pass3.innerHTML=''
            }

            // 验证码
            if(this.modify_password.check_code==''){
                this.$refs.check.innerHTML='请输入验证码'
                return false
            }else{
                this.$refs.check.innerHTML=''
            }

            return true
        },
        // 清空input
        clear_input(){
            this.modify_password.oldPassword=''
            this.modify_password.newPassword=''
            this.modify_password.confirmPassword=''
            this.modify_password.check_code=''

            this.$refs.pass1.innerHTML=''
            this.$refs.pass2.innerHTML=''
            this.$refs.pass3.innerHTML=''
        },
        //退出账号
        ExitAccount(){
            this.$confirm('确认退出当前账号?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=> {
                this.$http({
                    url: 'signOut',
                    data: {}
                }).then((res)=>{
                    if(res.code==1){
                        this.$message({
                            message:`${res.msg}`,
                            type: 'success'
                        });
                        this.$store.commit({
                            type:'set_userInfo',
                            data:{}
                        })
                        this.$router.push("/login")
                    }
                }).catch((err)=>{
                    console.log(err)
                })
            }).catch(()=> {

            });
        },
    }
}
</script>
<style lang="scss" scoped>
.account_center{
    background:#F4F4F4;
    display:flex;
    /*box-sizing:border-box;*/
    /*padding-top:110px;*/
    min-height:100%;
}
.box{
    width:900px;
    margin:auto;
    padding:80px  50px 40px;
    background:white;
    border-radius:8px;
    >li{
        display:flex;
        align-items: center;
    }
    >li:first-child{
        flex-direction: column;
        border-bottom:1px solid #dedfe0;
        position:relative;
        padding:10px 0 30px;
        >div:first-child{
            position:absolute;
            left:0;
            top:-40px;
        }
        >div:first-child:hover{
            color:#4285f4;
            cursor:pointer;
        }
    }
    >li:first-child~li{
        >i{
            display:block;
            width:80px;
            height:80px;
            margin-right:30px;
            border-radius:5px;
            >img{
                display:block;
                width:60px;
                height:60px;
                margin:10px;
            }
        }
        >div{
            flex:1;
            display:flex;
            align-items: center;
            justify-content: space-between;
            border-bottom:1px solid #CCCCCC;
            padding:35px 0;
            >div:first-child{
                h3{
                    font-size:30px;
                    line-height:50px;
                }
                p{
                    font-size:18px;
                    line-height:30px;
                    color:#999999;
                }
            }
            >div:last-child{
                >button{
                    border:none;
                    outline: none;
                    width:90px;
                    height:40px;
                    background:white;
                    border:1px solid #CCCCCC;
                    border-radius:5px;
                    font-size:18px;
                    color:#999999;
                    cursor:pointer;
                    margin-left:20px;
                }
                >button:hover{
                    background:#F4F4F4;
                }
                .bd:hover{
                    background:#FFEBD6;
                }
                .bd{
                    border:1px solid #FF9933;
                    background:white;
                    color:#FF9933;
                }
            }
        }
    }
}
.exit_account{
    display:flex;
    justify-content: center;
    align-items:center;
    margin-top:40px;
    >span{
        width:200px;
        height:50px;
        line-height:50px;
        text-align: center;
        border:1px solid rgba(204,204,204,1);
        border-radius:6px;
        cursor:pointer;
    }
    span:hover{
        color:#4285f4;
        border:1px solid #4285f4;
    }
}

.account_info{
    .modal_content{
        >li{
            padding:15px 0 0;
            >h3{
                text-align:left;
                font-size: 14px;
                color:#999999;
            }
            >p{
                font-size:18px;
                padding:15px 0  0 ;
                color:#333333;
            }
        }
        >li:first-child{
            text-align: center;
            >div{
                margin:10px auto 0;
            }
        }
    }
}

.account_password .modal_content,.verify_message .modal_content,.bind_phone .modal_content{
    >li{
        padding:12px 0;
        h3{
            font-size:18px;
            line-height:35px;
        }
        p{
            color:#999999;
            line-height:28px;
        }
        b{
            color:#FF3333;
        }
        >div:first-child{
            display:flex;
            align-items: center;
            justify-content: space-between;
        }
        .checkma{
            display:flex;
            align-items: center;
            position:relative;
            button{
                min-width:150px;
                border:none;
                outline:none;
                background:white;
                text-align:center;
                color:#FF9933;
                cursor:pointer;
                border-left:1px solid #CCCCCC;
                position:absolute;
                right:1px;
                top:10px;
            }
            .active{
                color:#999999;
                cursor:no-drop;
            }
        }
    }
}
.verify_message{
    .modal_content{
        >li:first-child{
            text-align: center;
        }
    }
}
.bind_phone{
    .modal_content{
        >li:first-child{
            div{
                position:relative;
                .select{
                    position:absolute;
                    left:1px;
                    top:1px;
                }
            }
        }
    }
}
.tip{
    color:#FF3333!important;
}
</style>
<style scoped>
.account_center >>> .el-dialog__header{
    text-align:center;
    padding: 20px 10px;
}
.account_center >>> .el-dialog__title{
    font-size:30px;
    line-height: 30px;
}
.account_center>>> .el-dialog__headerbtn .el-dialog__close{
    font-size:30px;
}
.account_center >>> .el-dialog__body{
    padding: 20px 50px 40px;
}
.account_center >>> .el-dialog__footer{
    text-align: center;
    padding: 0px 20px 40px
}

.account_center >>> .el-button{
    padding:12px 235px;
}
.account_center >>> .el-button--primary{
    background-color: #FF9933;
    border-color: #FF9933;
}

.account_center .checkma >>> .el-input__inner{
    padding:0 165px 0 15px;
}
.bind_phone .select >>> .el-input__inner{
    height:38px;
    line-height:38px;
    border:none;
    width:100px;
}
.bind_phone .input >>> .el-input__inner{
    padding:0 165px 0 115px;
}

/* 账户密码遮罩层问题 dialog不要遮罩层，设置背景色*/
.account_center >>> .el-dialog__wrapper{
    background: rgba(0,0,0,.5);
}
</style>
